/**
 * history 模块对 event 总线的订阅。
 * 订阅事件通道的追加事件，把游戏事件投影到主历史；
 * 由应用启动流程（app/index.ts）在挂载前注册，测试环境可自行注册/注销。
 */

import { getActivePinia } from 'pinia';
import {
  registerGameEventAppendedSubscriber,
  unregisterGameEventAppendedSubscriber,
} from '@/IsekaiRPG/modules/event/eventBus';
import { useStoryHistoryStore } from './historyStores';
import { StoryHistoryWriteService } from './storyHistoryWriteService';

const STORY_WRITE_SUBSCRIBER_KEY = 'history.storyWrite';

/**
 * 注册 history 对游戏事件的主历史投影订阅。
 */
export function registerStoryHistoryEventSubscribers(): void {
  registerGameEventAppendedSubscriber(STORY_WRITE_SUBSCRIBER_KEY, entry => {
    const activePinia = getActivePinia();
    const historyStore = activePinia ? useStoryHistoryStore(activePinia) : null;
    StoryHistoryWriteService.appendGameEvent(historyStore, entry);
  });
}

/**
 * 注销订阅（主要供测试环境清理）。
 */
export function unregisterStoryHistoryEventSubscribers(): void {
  unregisterGameEventAppendedSubscriber(STORY_WRITE_SUBSCRIBER_KEY);
}
